module.exports = __webpack_public_path__ + "1.5.0-unryo/img/elasticsearch.f9dd3807.svg";